module.exports = __webpack_public_path__ + "img/leval-2.02fa18b9.png";